/* ------------------------------------------------------------------
   Footer newsletter signup — AJAX submission for the Shopify customer
   form so the user gets in-place success/error feedback instead of a
   full page reload that scrolls them back to the top.

   The form's markup + action come from `{% form 'customer' %}` — we
   POST the same FormData to the same action URL, then parse the
   response HTML looking for the `.footer-2026__success` or
   `.footer-2026__error` block that the next-render Liquid would have
   produced. Whichever is present in the response gets swapped into
   place locally.
   ------------------------------------------------------------------ */

(function () {
  const form = document.querySelector('.footer-2026__form');
  if (!form) return;

  // Avoid double-binding if the section is re-rendered.
  if (form.dataset.footerSignupBound === 'true') return;
  form.dataset.footerSignupBound = 'true';

  const submitBtn = form.querySelector('.footer-2026__submit');
  const emailInput = form.querySelector('input[name="contact[email]"]');
  const fieldsRow = form.querySelector('.footer-2026__form-row');
  const SUCCESS_FALLBACK = 'Thanks, check your inbox for your 10% code.';
  const ERROR_FALLBACK = 'Something went wrong. Please try again.';
  let originalLabel = submitBtn ? submitBtn.textContent : 'Submit';

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim());
  }

  function setBusy(busy) {
    if (!submitBtn) return;
    submitBtn.disabled = busy;
    submitBtn.textContent = busy ? 'Sending…' : originalLabel;
  }

  function clearMessages() {
    form.querySelectorAll('.footer-2026__error, .footer-2026__success').forEach(function (el) {
      // Only remove ones we injected — keep server-rendered ones intact
      // on first paint. Our injected nodes carry data-footer-signup-msg.
      if (el.dataset.footerSignupMsg === 'true') el.remove();
    });
  }

  function showError(message) {
    clearMessages();
    if (emailInput) {
      emailInput.classList.add('footer-2026__input--error');
      emailInput.setAttribute('aria-invalid', 'true');
    }
    const p = document.createElement('p');
    p.className = 'footer-2026__error';
    p.dataset.footerSignupMsg = 'true';
    p.setAttribute('role', 'alert');
    p.textContent = message || ERROR_FALLBACK;
    form.appendChild(p);
  }

  function showSuccess(message) {
    clearMessages();
    if (fieldsRow) fieldsRow.remove();
    const p = document.createElement('p');
    p.className = 'footer-2026__success';
    p.dataset.footerSignupMsg = 'true';
    p.setAttribute('role', 'status');
    p.setAttribute('aria-live', 'polite');
    p.textContent = message || SUCCESS_FALLBACK;
    form.appendChild(p);
  }

  function parseResponse(html) {
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const responseForm = doc.querySelector('.footer-2026__form');
      if (!responseForm) return { kind: 'success', message: SUCCESS_FALLBACK };
      const success = responseForm.querySelector('.footer-2026__success');
      if (success) {
        return { kind: 'success', message: (success.textContent || '').trim() || SUCCESS_FALLBACK };
      }
      const error = responseForm.querySelector('.footer-2026__error');
      if (error) {
        return { kind: 'error', message: (error.textContent || '').trim() || ERROR_FALLBACK };
      }
      // No explicit marker — assume success (Shopify usually redirects
      // to ?customer_posted=true which renders the success branch).
      return { kind: 'success', message: SUCCESS_FALLBACK };
    } catch (e) {
      return { kind: 'success', message: SUCCESS_FALLBACK };
    }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    // Client-side email check before bothering the server.
    if (!emailInput || !isValidEmail(emailInput.value)) {
      showError('Please enter a valid email address.');
      if (emailInput) emailInput.focus();
      return;
    }

    setBusy(true);
    const formData = new FormData(form);

    fetch(form.getAttribute('action') || '/contact#contact_form', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      redirect: 'follow',
    })
      .then(function (res) {
        if (!res.ok && res.status !== 0) {
          throw new Error('Submit failed (' + res.status + ')');
        }
        return res.text();
      })
      .then(function (html) {
        const result = parseResponse(html);
        if (result.kind === 'success') {
          showSuccess(result.message);
        } else {
          showError(result.message);
          setBusy(false);
        }
      })
      .catch(function (err) {
        console.error('[footer-2026] signup failed', err);
        showError(ERROR_FALLBACK);
        setBusy(false);
      });
  });

  // Clear error styling once the user starts typing again.
  if (emailInput) {
    emailInput.addEventListener('input', function () {
      emailInput.classList.remove('footer-2026__input--error');
      emailInput.setAttribute('aria-invalid', 'false');
      const err = form.querySelector('.footer-2026__error[data-footer-signup-msg="true"]');
      if (err) err.remove();
    });
  }
})();
